import React, { useState } from "react";
import { Button, Col, Row, Checkbox } from "antd";
import { AiFillQuestionCircle } from "react-icons/ai";
import { CheckCircleFilled } from "@ant-design/icons";

import { COLORS } from "../../config/theme";
import { freeBag } from "../../assets/images";

const PlanCard = ({
  planType,
  paymentStatus,
  subscriptionType,
  features,
  cancelSubscriptionModal,
  setShowPurchaseModal,
  setSelectedPlan,
  wavecardQuantity,
}) => {
  const { primaryDark, danger, lightGray, activePlan } = COLORS;
  const [acceptAgreement, setAcceptAgreement] = useState(
    planType === "PROFESSIONAL" ? true : false
  );
  const handlePurchasePlan = () => {
    setSelectedPlan(planType);
    setShowPurchaseModal();
  };
  const calculateFinalPricing = (wavecardQuantity) => {
    let finalPrice = 0;
    if (wavecardQuantity <= 0) {
      return planType === "BUSINESS" ? 8 : 7;
    }
    if (planType === "BUSINESS") {
      if (wavecardQuantity >= 0 && wavecardQuantity < 10) {
        finalPrice = 8;
      } else if (wavecardQuantity >= 10 && wavecardQuantity < 100) {
        finalPrice = 6;
      } else if (wavecardQuantity >= 100) {
        finalPrice = 5;
      }
    } else if (planType === "ENTERPRISE") {
      if (wavecardQuantity >= 0 && wavecardQuantity < 10) {
        finalPrice = 7;
      } else if (wavecardQuantity >= 10 && wavecardQuantity < 100) {
        finalPrice = 7;
      } else if (wavecardQuantity >= 100) {
        finalPrice = 6;
      }
    }

    return finalPrice;
  };
  return (
    <Col
      md={24}
      lg={7}
      style={{
        marginTop: "1rem",
        display: "flex",
        border: "1px solid gray",
        borderRadius: "0.5rem",
        textAlign: "center",
        paddingTop: "1rem",
        minWidth: "auto",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        paddingBottom: "1rem",
        minHeight: "35rem",
        flexDirection: "column",
        backgroundColor: paymentStatus ? activePlan : "white",
      }}
    >
      {planType !== "PROFESSIONAL" && (
        <img
          src={freeBag}
          alt="free"
          style={{
            width: 130,
            borderRadius: 0,
            position: "absolute",
            top: "-3rem",
            left: "-3rem",
          }}
        />
      )}
      <Row span={24}>
        <Col
          style={{
            textAlign: "left",
          }}
          xs={24}
          sm={24}
          md={24}
          lg={18}
        >
          <p
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginLeft: "3rem",
              color: paymentStatus ? "white" : "black",
            }}
          >
            {`${planType.charAt(0) + planType.slice(1).toLowerCase()} Plan`}
          </p>
        </Col>
      </Row>
      {planType === "PROFESSIONAL" ? (
        <Row justify="center" align="center" style={{ margin: "1rem 0" }}>
          <p
            style={{
              color: paymentStatus ? "white" : "black",
              fontSize: "2rem",
              fontWeight: "800",
            }}
          >
            Free
          </p>
        </Row>
      ) : (
        <Row
          justify="center"
          align="center"
          style={{ margin: "1rem", flexDirection: "column" }}
        >
          <p
            style={{
              color: paymentStatus ? "white" : "black",
              fontSize: "2rem",
              fontWeight: "800",
            }}
          >
            {`AU$ ${calculateFinalPricing(wavecardQuantity)}`}
            <span
              style={{
                color: paymentStatus ? "white" : "black",
                fontSize: "1rem",
                fontWeight: "500",
              }}
            >
              {` /per card`}
            </span>
          </p>
          {planType === "ENTERPRISE" && (
            <p
              style={{
                marginRight: "2.8rem",
                color: paymentStatus ? "white" : "black",
                fontWeight: "600",
              }}
            >
              minimum 10 users
            </p>
          )}
          {/* {(planType === "ENTERPRISE" || planType === "BUSINESS") && (
            <p
              style={{
                // marginRight: "2.8rem",
                color: paymentStatus ? "white" : "black",
              }}
            >
              Price changes by increasing the cards quantity
            </p>
          )} */}
        </Row>
      )}
      <Row
        span={24}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {features.map((item, index) => {
          return (
            <Row key={index} span={24}>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
                span={5}
              >
                <CheckCircleFilled
                  style={{
                    fontSize: "1.2rem",
                    color: paymentStatus ? "white" : "black",
                  }}
                />
              </Col>
              <Col
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
                span={19}
              >
                <p
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    color: paymentStatus ? "white" : "black",
                  }}
                >
                  {item?.cardListTitle}
                </p>
                <div
                  style={{
                    display: "flex",
                    marginLeft: "1rem",
                  }}
                >
                  <p data-tip={item.cardListDetail}>
                    <AiFillQuestionCircle
                      style={{
                        color:
                          subscriptionType === planType ? "blue" : "#009dff",
                      }}
                    />
                  </p>
                </div>
              </Col>
            </Row>
          );
        })}
      </Row>
      <div
        style={{
          borderTop: "2px solid gray",
          opacity: "30%",
          marginTop: "2rem",
        }}
      />

      <Row
        span={24}
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "1rem 0rem",
        }}
      >
        <Checkbox
          disabled={paymentStatus || planType === "PROFESSIONAL" ? true : false}
          style={{ marginRight: "0.5rem" }}
          checked={
            paymentStatus || planType === "PROFESSIONAL"
              ? true
              : acceptAgreement
          }
          onChange={() => setAcceptAgreement((prev) => !prev)}
        />
        <a
          href="https://wavecards.com.au/terms-and-conditions/"
          target="_blank"
          rel="noreferrer"
        >
          I accept terms and conditions
        </a>
      </Row>
      {planType === "PROFESSIONAL" ? (
        <Row
          span={24}
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "2rem 0",
          }}
        >
          <p
            style={{
              fontSize: "1.3rem",
              fontWeight: "bold",
              color: paymentStatus ? "white" : "black",
            }}
          >
            Free with wave card purchase
          </p>
        </Row>
      ) : (
        <Row
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "2rem",
          }}
          span={24}
        >
          {paymentStatus ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                shape="round"
                type="primary"
                style={{
                  background: danger,
                  borderColor: primaryDark,
                }}
                onClick={cancelSubscriptionModal}
              >
                Cancel
              </Button>
              <Button
                shape="round"
                type="primary"
                style={{
                  background: danger,
                  borderColor: primaryDark,
                }}
                onClick={handlePurchasePlan}
              >
                Change Plan
              </Button>
            </div>
          ) : (
            <Button
              shape="round"
              type="primary"
              disabled={!acceptAgreement}
              style={{
                background: acceptAgreement ? primaryDark : lightGray,
                borderColor: primaryDark,
              }}
              onClick={handlePurchasePlan}
            >
              Choose
            </Button>
          )}
        </Row>
      )}
    </Col>
  );
};

export default PlanCard;
